import { RouteRecordRaw } from 'vue-router';
import store from '@/store';
import { ModalServices } from '@/services/ModalServices';
import { VillageConfigClient } from '@/services/Services';
import { StorageServices } from '@/services/StorageServices';
import selectVillage from './selectVillage';
import villageList from './villageList';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/villages',
            name: 'villages',
            component: () => import("./layout.vue"),
            meta: {
                bottomCutFixed: true,
            },
            children: [
                ...selectVillage.routes(),
                ...villageList.routes()
            ],
        },
    ];
};